var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value && _vm.value[_vm.identifier])?_c('p',{staticClass:"mb-0"},[_vm._v("\n    "+_vm._s(_vm.value[_vm.identifier])+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }